import script from "./FeatureRow.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureRow.vue?vue&type=script&setup=true&lang=js"

import "./FeatureRow.vue?vue&type=style&index=0&id=2fbb53f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbb53f1"]])

export default __exports__